import OtherList from '@/components/ProductCommon/OtherList';
import { LineSpace } from '@/components/ProductComponents';
import { TextBanner, TextOnImage, TextWithImage } from '@/components/ProductDetailComponents';
import EFVideo from '@/components/UI/EFVideo';
import Image from '@/components/UI/Image';
import EFReplayH5 from '@/components/UI/svg/Icons/EFReplayH5';
import { getDetaileMoreProducts } from '@/utils';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
import ProductRecommand from '@elem/compCommon/ProductRecomand';

const { EFPic } = createEFPic('/media/100w_rigid/pc/');

const product: any = {
    us: ['product_ps_river_river_pro_720', 'product_ps_delta_delta_1300', 'product_ps_delta_delta_max'],
    cis: ['product_ps_delta_delta_max', 'product_ps_delta_delta_pro', 'product_ps_river_river_256'],
    eu: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    uk: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    de: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    fr: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    es: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    it: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    tw: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    kr: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    cn: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    br: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_2_max'],
    nl: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_2_max'],
    mx: ['product_sp_400w_rigid_solar_panel', 'product_ps_delta_delta_2', 'product_ps_delta_delta_3_s'],
};

export default function Content() {
    const { gloproductlist, useLang, useRouter, useRef } = useGlobal();
    const videoRef = useRef(null);
    const { locale } = useRouter();
    const { t } = useLang('100wrigidsolarpanel');

    const videoSource: any = {
        us: ['/video/solarpanels_100w/4.webm', '/video/solarpanels_100w/4.mp4'],
        de: ['/video/solarpanels_100w/4_de.webm', '/video/solarpanels_100w/4_de.mp4'],
        fr: ['/video/solarpanels_100w/4_fr.webm', '/video/solarpanels_100w/4_fr.mp4'],
        jp: ['/video/solarpanels_100w/4_jp.webm', '/video/solarpanels_100w/4_jp.mp4'],
        cis: ['/video/solarpanels_100w/4_ru.webm', '/video/solarpanels_100w/4_ru.mp4'],
    };

    const textData3 = {
        synopsis: t('solarpanels_100w.third_title'),
        desc: t('solarpanels_100w.third_des'),
        bgImgs: ['/media/100w_rigid/pc/3_screen.webp', '/media/100w_rigid/pc/3_screen.jpg'],
    };

    const textData4 = {
        title: t('solarpanels_100w.four_title'),
        synopsis: t('solarpanels_100w.four_synopsis'),
        desc: t('solarpanels_100w.four_des'),
        bgImgs: ['/img/productDetails/solarpanel_110w/3.webp', '/img/productDetails/solarpanel_110w/3.jpg'],
    };

    const textData5 = {
        title: t('solarpanels_100w.five_title'),
        synopsis: t('solarpanels_100w.five_synopsis'),
        desc: t('solarpanels_100w.five_des'),
        phrase: t('solarpanels_100w.five_phrase'),
        bgImgs: ['/media/100w_rigid/pc/4.webp', '/media/100w_rigid/pc/4.jpg'],
    };

    const textData6 = {
        img_url: ['/media/100w_rigid/pc/4_camera.webp', '/media/100w_rigid/pc/4_camera.jpg'],
        title: t('solarpanels_100w.six_title'),
        synopsis: t('solarpanels_100w.six_synopsis'),
        desc: t('solarpanels_100w.six_des'),
    };

    const textData7 = {
        img_url: ['/media/100w_rigid/pc/7.webp', '/media/100w_rigid/pc/7.jpg'],
        title: t('solarpanels_100w.seven_title'),
        synopsis: t('solarpanels_100w.seven_synopsis'),
        desc: t('solarpanels_100w.seven_des'),
    };

    const textData8 = {
        img_url: ['/media/100w_rigid/pc/6_drone@2x.webp', '/media/100w_rigid/pc/6_drone@2x.jpg'],
        title: t('solarpanels_100w.eight_title'),
        synopsis: t('solarpanels_100w.eight_synopsis'),
        desc: t('solarpanels_100w.eight_des'),
    };

    const props = {
        more: `https://${locale}.ecoflow.com/pages/portable-power-stations`,
        data: [
            {
                productId: '9935710912788',
                variantId: '51194414924052',
            },
            {
                productId: '9935700132116',
                variantId: '51194378682644',
            },
            {
                productId: '9935714386196',
                variantId: '51427570286868',
            },
        ],
    };

    return (
        <div className={`${css.animationWrapper} solarPanelModule`}>
            <LineSpace height={180} background="transparent" />
            <div className="banner-content">
                <div className="section section1">
                    <div className="section sec1-top">
                        <div className="tit">{t('solarpanels_100w.second_hight_conversion_rate')}</div>
                        <div className="bg-img">
                            <EFPic name={['sec1-top.webp', 'sec1-top.jpg']} className="fullImgs" alt={t('solarpanels_100w.second_hight_conversion_rate')} />
                        </div>
                    </div>
                    <div className="section sec1-btm">
                        <div className="tit">
                            <div className="text1">{t('solarpanels_100w.second_adjustable')}</div>
                            <div className="text2">{t('solarpanels_100w.second_highly_protective')}</div>
                        </div>
                        <div className="bg-img">
                            <EFPic name={['sec2-btm.webp', 'sec2-btm.jpg']} className="fullImgs" alt={t('solarpanels_100w.second_powerfully')} />
                        </div>
                    </div>
                </div>
                <div className="section">
                    <div className="section sec2-top">
                        <div className="tit">
                            <div className="text1">{t('solarpanels_100w.second_powerfully')}</div>
                            <div className="text2">{t('solarpanels_100w.second_mounting_holes')}</div>
                        </div>
                        <div className="bg-img">
                            <EFPic name={['sec2-top.webp', 'sec2-top.jpg']} className="fullImgs" alt={t('solarpanels_100w.second_powerfully')} />
                        </div>
                    </div>
                    <div className="section sec2-middle">
                        <div className="tit">
                            {locale === 'fr' ? (
                                <>
                                    <div className="text2">{t('solarpanels_100w.second_waterproof')}</div>
                                    <div className="text1">{t('solarpanels_100w.second_ip')}</div>
                                </>
                            ) : (
                                <>
                                    <div className="text1">{t('solarpanels_100w.second_ip')}</div>
                                    <div className="text2">{t('solarpanels_100w.second_waterproof')}</div>
                                </>
                            )}
                        </div>
                        <div className="bg-img">
                            <EFPic name={['sec2-middle.webp', 'sec2-middle.jpg']} className="fullImgs" alt={t('solarpanels_100w.second_waterproof')} />
                        </div>
                    </div>
                    <div className="section sec2-btm">
                        <div className="tit">{t('solarpanels_100w.second_easy_to_plug')}</div>
                        <div className="bg-img">
                            <EFPic name={['sec1-btm.webp', 'sec1-btm.jpg']} className="fullImgs" alt={t('solarpanels_100w.second_easy_to_plug')} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="textData3">
                <LineSpace height={180} background="transparent" />
                <TextOnImage data={textData3} config={{ position: 'top' }} />
            </div>
            <div className="textData6">
                <LineSpace height={220} background="transparent" />
                <TextWithImage data={textData6} config={{ position: 'top' }} />
            </div>
            <LineSpace height={220} background="transparent" />
            <div className="text-and-video">
                <div className="text-container">
                    <TextBanner data={textData4} />
                </div>
                <EFVideo ref={videoRef} sources={videoSource[locale] || videoSource.us} className="video" width={500} height={540} loop={false} />
                <div className="play-icon" onClick={() => videoRef.current?.play()}>
                    <EFReplayH5 width="44px" height="44px" />
                </div>
            </div>
            <LineSpace height={220} background="transparent" />
            <div className="container textData6">
                <TextOnImage data={textData5} config={{ position: 'right' }} />
            </div>
            <div className="textData7">
                <LineSpace height={220} background="transparent" />
                <TextWithImage data={textData7} config={{ position: 'top' }} />
                <div className="img-text text-left">{t('solarpanels_100w.seven_img_left')}</div>
                <div className="img-text text-right">{t('solarpanels_100w.seven_img_right')}</div>
            </div>
            <div className="textData8">
                <LineSpace height={220} background="transparent" />
                <TextWithImage data={textData8} config={{ position: 'top' }} />
            </div>
            <div className="whatsBox">
                <LineSpace height={220} background="transparent" />
                <p className="title">{t('solarpanels_100w.nine_title')}</p>
                <div className="boxImg">
                    <div className="img">
                        <Image
                            src="/media/100w_rigid/pc/08.png"
                            className="fullImgs"
                            layout="fill"
                            alt={t('solarpanels_100w.nine_title')}
                            aria-label={t('solarpanels_100w.nine_title')}
                        />
                    </div>
                    <p className="note">{t('solarpanels_100w.nine_note')}</p>
                </div>
            </div>
            <LineSpace height={280} background="transparent" />
            {['nl'].includes(locale) ? (
                <ProductRecommand {...props} />
            ) : (
                <OtherList
                    data={getDetaileMoreProducts(
                        gloproductlist,
                        product[locale] || product.us,
                        '',
                        '',
                        `https://${locale}.ecoflow.com/collections/portable-power-stations`,
                    )}
                />
            )}
        </div>
    );
}
